'use strict';
var dialog = require('./dialog');
var util = require('./util');
/**
 * @function
 * @description Initializes the tooltip-content and layout
 */
exports.init = function () {
	$('body').on('click', '.tooltip', function (e) {
		e.preventDefault();
		var content = $(this).find('.tooltip-content'),
			target = $('tooltip-container').length > 0 ? $('#tooltip-container') : $('<div id="#tooltip-container"></div>');
		if (content.length > 0) {
			dialog.tooltip(content.html(), target);
		}
	});
	if (!util.viewport.isMobile() && !util.isMobile()) {
		$(document).tooltip({
			items: '.form-field-tooltip .tooltip',
			track: false,
			content: function () {
				return $(this).find('.tooltip-content').html();
			},
			position: {
				my: $('.pt_account').length ? 'right+10 bottom-15' : 'left-10 bottom-15',
				at: 'center top',
				using: function (position, feedback) {
					$(this).css(position);
					$('<div>')
						.addClass('arrow')
						.addClass(feedback.vertical)
						.addClass(feedback.horizontal)
						.appendTo(this);
				}
			}
		});
	}
};
